/**
 * Legacy /reports/$userId route — redirects to the new /team/$userId.
 *
 * The per-rep drill-down moved out of /reports (which is now strictly
 * the company-wide analytics page) into /team (the operational
 * "what's this person working on" view). This redirect keeps:
 *   - external bookmarks / chat links pointing at the old path
 *   - the visual smoke harness's `/reports/{userId}` checks
 * working without surprise 404s.
 *
 * Same Manager+ gate as the destination route applies via /_app/team.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reports/$userId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/team/$userId",
      params: { userId: params.userId },
      replace: true,
    });
  },
});
